<template>
  <div id="pc_app">
    <div class="saas-tree" v-show="fullScreen">
      <!-- <router-link to="/"><div class="saas-icon"></div></router-link> -->
      <div class="left-header">
        <router-link :to="isService?'/home':'/thome/5'">
          <div class="saas-new-icon" :style="{backgroundImage:'url('+ logoUrl +')'}"></div>
        </router-link>
        <div class="switch-menu" @click="handleChangeMenus" v-if="!!isShowUpgrade">
          <span v-show="isService">服务升级</span>
          <span v-show="!isService">经营转型</span>
          <i class="el-icon-sort"></i>
        </div>
      </div>
      <div class="saas-menu-search">
        <el-input
          placeholder="请输入关键词" 
          v-model="search" @input="menuSearch">
          <i slot="prefix" class="el-input__icon"><img src="//img1.jianyewy.com/0eefa0cbb53d159923a1dd49499dbd1c.png" style="height: 14px;width: 14px;margin-left: 5px;"/></i>
        </el-input>
      </div>
      <div class="menu-out">
          <ex-menu :list="currentList" :menuActive="menuActive" :tabslist="tabslist" v-model="tabValue"></ex-menu>
      </div>
      <div :class="hotclass" v-if="promotion">
        <div v-show="hot" class="is-hot">
          <a :href="promotion.linkName"><img class="small" :src="promotion.smallImageUrl" /></a>
          <img class="open" @click="changeCollapse" src="//img1.jianyewy.com/fee24e939242662b58acd15550ad6281.png" />
        </div>
        <div v-show="!hot" class="is-hot2">
          <!-- <div>
            <p>{{ this.promotion.title }}</p>
            <span>副标题内容位置</span>
          </div> -->
          <a :href="promotion.linkName"><img :src="promotion.bigImageUrl" /></a>
          <i class="el-icon-close" @click="closePromotion"></i>
        </div>
      </div>
    </div>
    <div class="saas-content">
      <div v-show="fullScreen" :class="['saas-menu',!isService?'bgc2':'bgc1']">
        <div class="menu-right fl">
            <div :class="{select: (currentIndex==-1)}" style="margin-right: -5px;"><div class="header-menu" @click="topMenuClickHome(-1)">
              <!-- <img class="top-icon" src="//img1.jianyewy.com/7459badc69f6b1fc23c98bfb3c9a6853.png" /> -->
              <div class="top-icon" style="background-image: url(//img1.jianyewy.com/e33ca2e172d930234b5868989d07f703.png)"></div>
              首页</div></div> 
            <div v-for="(item,index) of menuLs" :key="index" :class="{select: (currentIndex==index)}"><div class="header-menu" @click="topMenuClick(item,index)">
            <!-- <img class="top-icon" :src="item.icon" /> -->
            <div class="top-icon" :style="'background-image: url('+item.icon+')'"></div>
            {{ item.name }}</div></div> 
        </div> 
        <!-- <a :href="item.frontUrl"></a> -->
        <!--<router-link to="/"><el-col><div class=""><img class="top-icon" src="//img1.jianyewy.com/4e12db645ffe8635b6aab763f1b1b7c4.png" /> 商业</div></el-col></router-link>
        <a href="//c.jianyewy.com" target="_blank"><el-col><div class=""><img class="top-icon" src="//img1.jianyewy.com/8291d37569352a43189c990c345eeee3.png" /> 物业</div></el-col></a>
        <a href="//sc.jianyewy.com" target="_blank"><el-col><div class=""><img class="top-icon" src="//img1.jianyewy.com/73a430f4000e4cc9c1305ddaa050c023.png" /> IOT</div></el-col></a>-->
        <div class="fr">
          <!--<el-col class="grid-item"><img style="width: 19px;" src="//img1.jianyewy.com/9d4bb9b828c864e900676f42e6842cc2.png" /></el-col>-->
          <el-row>
            <el-col :class="[{'grid-item1':!isService},'grid-item', {select: isShowNotice}]">
              <a class="dropdown-toggle" @click="handleShowNotice($event)">
              <el-badge :value="tipNum" :max="99" class="badge-item">
                <img class="lingdang" style="width: 24px;" src="//img1.jianyewy.com/7fc4271865f581f6fee61c9f7c55a466.png" />
              </el-badge>
              </a>
              <ul class="dropdown-menu" ref="dropdownMenu" @click.stop="" @mouseleave="handlehideNotice()">
                <li class="header">您有{{tipNum}}个系统通知</li>
                <li>
                  <div class="content">
                    <ul v-for="(item,index) in noticeList" v-if="noticeList" :key="index">
                      <li><a href="javaScript:void(0)" @click="noticesClick(item)">{{item.notificaTitle}}</a></li>
                    </ul>
                  </div>
                </li>
                <li class="footer"><a @click="noticesAll()">查看所有信息</a></li>
                <!--<li class="footer"><a><router-link :to="{ path:'/notice/list' }">查看所有信息</router-link></a></li>-->
              </ul>
            </el-col>
            <!--
            <el-col :class="[{'grid-item1':!isService},'grid-item', 'saas-set']" @click.native="updPaw()"><img style="width: 18px;" src="//img1.jianyewy.com/b16ebd3510af2eba3fce5f9e0d53d6d9.png" /></el-col>
            <el-col :class="[{'grid-item1':!isService},'grid-item', 'saas-out']" @click.native="loginOut()"><img style="width: 19px;" src="//img1.jianyewy.com/9d37140d39e84b7fb48960c4bd6de8d1.png" /></el-col>
            <el-col :class="[{'grid-item1':!isService},'grid-item']"><img style="width: 40px;" src="//img1.jianyewy.com/e1e5c8b2f29ea3cf32890bb47ec40c65.png" /></el-col>
            -->
            <el-col :class="[{'grid-item1':!isService},'grid-item',{'user-header':isService},{'user-header1':!isService},{select: topmenuVis}]"> 
              <a class="dropdown-toggle" @click.stop="clickShowMenus">
                <img class="header-icon" style="width: 24px;" src="//img1.jianyewy.com/f7f955f8ce23d2c6d596f92ce1b80c87.png" />
                <span :class="{'color-black':!isService}">{{ $store.state.user.realName || '用户您好' }}</span>
                <div class="icon-arrow">
                  <img class="arrow" style="width: 10px;" :src="topmenuVis?'//img1.jianyewy.com/0b6a8a518f8a016879216aac9e38ca1f.png':'//img1.jianyewy.com/1aa060eb4d8c8c008961db2204a6b3c3.png'" />
                </div>
              </a>
            </el-col>
          </el-row>  
          <div class="dropdown-header" v-show="topmenuVis" @mouseleave="handlehideMenus()">
            <ul @click.stop="headerClick()">
              <li v-for="(item,index) in headerMenus" v-if="headerMenus" :key="index">
                <a href="javaScript:void(0)" @click="clickTopMenu(item)">
                  <img style="width: 16px; height: 16px;" :src="item.icon||'//img1.jianyewy.com/d64c148a84baf713a5241b52879304be.png'" />
                  <span>{{item.name}}</span>
                </a>
                <div class="bot-line"></div>
              </li>
              <!-- <li>
                <a @click="updPaw()">
                  <img style="width: 16px; height: 16px;" src="//img1.jianyewy.com/f809fe3afbde7f19f072adba78d5479a.png" />
                  <span>修改密码</span>
                </a>
                <div class="bot-line"></div>
              </li> -->
              <li class="footer"><a @click="loginOut()"><span>退出</span></a></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="saas-tabs">
        <div class="tabs-left">
          <el-tabs v-model="tabValue" type="card" @tab-remove="removeTab" 
              @tab-click="clickTab">
            <el-tab-pane
              label="首页"
              :name="!isService?'shouye1':'shouye'"
              :frontUrl="!isService?'/thome/5':'/'"
            >
            </el-tab-pane>
            <el-tab-pane
              v-for="(item, index) in tabslist"
              :key="item.name"
              :label="item.title"
              :name="item.name"
              :frontUrl="item.url"
              :closable="item.title!='首页'"
            >
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="tabs-menu">
          <el-menu class="el-menu-demo" mode="horizontal" active-text-color="#909399">
            <el-submenu index="1">
              <template slot="title">操作</template>
              <el-menu-item index="1-1" @click="removeTab(tabValue)">关闭当前</el-menu-item>
              <el-menu-item index="1-2" @click="closeAll()">关闭所有</el-menu-item>
              <el-menu-item index="1-4" @click="closeOther()">关闭其他</el-menu-item>
              <el-menu-item index="1-3" @click="repush(tabValue)">刷新当前页面</el-menu-item>
            </el-submenu>
          </el-menu>
        </div>
      </div>
      <div class="saas-view">
        <template v-for="item in skylinelist">
          <iframe-view :frontUrl="item.url" :ifid="item.name" v-show="item.name==tabValue" v-if="item.isEx"></iframe-view>
        </template>
        <keep-alive :include="includeArr">
          <router-view v-if="isRouterAlive" v-show="!isSkyLine"></router-view>
        </keep-alive>
      </div>
    </div>

    <el-dialog
      :title="modal.title"
      :visible.sync="modal.show"
      width="30%">
      <div class="text-center">{{ modal.message }}</div>
      <div slot="footer" class="dialog-footer text-center">
        <el-button type="primary" @click="modal.buttons&&modal.buttons[0].click()">{{ modal.buttons&&modal.buttons[0].text }}</el-button>
      </div>
    </el-dialog>
    <el-dialog title="通知" custom-class="noticeDlg" :visible.sync="noticeVisible" :close-on-click-modal="false" :show-close="false" width="600px">
      <el-container>
        <el-header height="auto">
          <div class="title">{{ noticeItem.title }}</div>
          <div class="des">发布人：{{ noticeItem.sendOrganName }}&nbsp;&nbsp;&nbsp;{{ noticeItem.sendTime | dateFormat('yyyy-MM-dd hh:mm:ss') }}</div>
        </el-header>
        <el-main v-if="noticeVisible">
          <div class="content" v-html="noticeItem.notice"></div>
          <div class="line"></div>
          <div class="footer">
            <el-button type="primary" @click="closeAlert(noticeItem.id)">我知道了</el-button>
          </div>
        </el-main>
      </el-container>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import axios from 'axios';
import menus from '../../static/menus';
import iframeView from '../pcmodules/home/iframeView';
import { Message } from 'element-ui';
import Filter from '../utils/filter';
export default {
  data() {
    return {
      activeIndex: '1',
      activeIndex2: '1',
      load: null,
      hot: false,
      hotclass: 'hot hot-ncollapse',
      promotion: null,
      search: '',
      menuLs: [],
      menuActive: '',
      currentList: [],
      currentIndex: 0,
      allTwoList: [],
      tipNum: 0,
      noticeList: [],
      isService: true,
      tabslist: [],
      tabValue: '',
      isRouterAlive: true,
      skylinelist: [],
      includeArr: [],
      isSkyLine: false,
      noticeVisible: false,
      topmenuVis: false,
      headerMenus: [],
      noticeItem: { // 弹框通知对象
        id: '',
        title: '',
        notice: '',
        sendTime: '',
        sendOrganName: ''
      },
      isShowNotice: false,
      isFromGW:false,
      logoUrl:'//wy.jianyewy.com/wycrm/static/images/login/logo1.png',
      isShowUpgrade:0,//1 是  0 否
    };
  },
  computed: {
    ...mapState(['fullScreen', 'loading', 'modal'])
  },
  watch: {
    loading: function(loading) {
      if (this.load && !loading) {
        this.load.close();
      }
      if (loading) {
        this.load = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.7)',
          target: document.querySelector('.saas-view')
        });
      }
    },
    tabslist: function() {
      // this.skylinelist = this.tabslist.filter((data, index) => {
      //   return data.isSkyLine;
      // });
      let tabs = this.tabslist;
      let tabsNames = [];
      this.tabslist.forEach((data, index) => {
        tabsNames.push(data.name);
      });
      let skysNames = [];
      this.skylinelist.forEach((data, index) => {
        skysNames.push(data.name);
      });
      for (let i=0; i<tabs.length; i++) {
        if (tabs[i].isSkyLine){
          if(skysNames.indexOf(tabs[i].name)===-1){
            let s = tabs[i];
            s.isEx = true;
            this.skylinelist.push(s);
          } else {
            for (let j=0; j<this.skylinelist.length; j++) {
              if(this.skylinelist[j].name == tabs[i].name) {
                this.skylinelist[j].isEx = true;
                if(this.skylinelist[j].url != tabs[i].url) {
                  this.skylinelist[j].url = tabs[i].url;
                }
              }
            }
          }
        }
      }
      for (let k=0; k<this.skylinelist.length; k++) {
        if(tabsNames.indexOf(this.skylinelist[k].name)===-1){
          this.skylinelist[k].isEx = false;
        }
      }
      // include
      this.includeArr = ['home'];
      this.tabslist.forEach((data, index) => {
        if (data.isSkyLine){
        } else {
          if (data.routeName && data.routeName != ''){
            this.includeArr.push(data.routeName);
            console.log(this.includeArr);
          }
        }
      });
    },
    tabValue: function (){
      if (this.tabValue == 'shouye' || this.tabValue == 'shouye1') {
        this.isSkyLine =  false;
        return;
      }
      this.tabslist.forEach((data, index) => {
        if (data.name == this.tabValue) {
          this.isSkyLine = data.isSkyLine || false;
        }
      });
    }
  },
  update() {
    if (location.pathname.match(/^\/account/)) {
      document.querySelector('.saas-menu').style.display = 'none';
      document.querySelector('.saas-tree').style.display = 'none';
      document.querySelector('.saas-tabs').style.display = 'none';
    } else {
      document.querySelector('.saas-menu').style.display = 'block';
      document.querySelector('.saas-tree').style.display = 'block';
      document.querySelector('.saas-tabs').style.display = 'block';      
    }
  },
  beforeMount(){
    console.log('pcapp beforemounted')
    // 从cookie 中获取数据写入
    let userJson=JSON.parse(decodeURIComponent(window.top.long.getCookie('f_u_d')));
      // 用完即焚
    window.top.long.delCookie('f_u_d');
    console.log('userJson',userJson);
    if(userJson){
      // 同步vueX
      this.$store.commit('userInfo',userJson.data);
      // 设置环境标记
      this.isFromGW=true;
      // 绕过登录接口，此处补充录入localstorage数据
      localStorage.setItem('user',JSON.stringify(userJson.data));
      localStorage.setItem('source','gateway');
    }
    else{
      console.warn('未能在cookie中找到f_u_d 信息');
      if(localStorage.getItem('source')==='normal'){
        // 已登陆状态且是千丁云普通用户
        this.isFromGW=false;
      }
      else if(localStorage.getItem('source')==='gateway'){
        // 已登陆状态且是第三方通过重定向进入页面
        this.isFromGW=true;
      }
      else{
        // 没能从localstorage中获取 source 参数
        this.isFromGW=false;
        localStorage.setItem('source','normal');
      }
    }
  },
  mounted() {
    //特殊处理 外层不属于路由控制 可以用其他方案
    if (location.pathname.match(/^\/account/) || location.pathname == '/') {
      console.log('pcapp mounted ififif')
      document.querySelector('.saas-menu').style.display = 'none'; // totest
      document.querySelector('.saas-tree').style.display = 'none';
      document.querySelector('.saas-tabs').style.display = 'none';
    } else {
      console.log('pcapp mounted else else else')
    //   this.menuList().then(data => {
    //     this.menuLs = data.data;
    //     let list = [];
    //     for (let i = 0; i < data.data.length; i++) {
    //       data.data[i].subMenuList && list.push(...data.data[i].subMenuList);
    //     }
    //     this.allTwoList = list;
    //     let index = sessionStorage.getItem('curMenuIndex') || 0;
    //     this.currentIndex = index;
    //     this.selectList = this.currentList = data.data.length > 0 ? data.data[index].subMenuList : [];
    //     this.menuActive = sessionStorage.getItem('menuActive') || '';
    //   });
      this.noticeAlert();
      document.addEventListener('click', this.handleBodyClick);
      this.getNotices({
        page: 1,
        size: 1000,
        status: 0
      }).then(res => {
        if (res.data && res.data.entity && res.data.entity.data) {
          this.tipNum = res.data.entity.data.length;
          this.noticeList = res.data.entity.data;
        } else {
          this.tipNum = 0;
          this.noticeList = [];
        }
        // let data1 = [{"id":37866053,"notificaType":1,"referId":"168","notificaSource":2,"receiverType":3,"receiverId":"2017112216353330041","receiveMethod":"1100","displayTerminal":"1000","notificaTitle":"消息","notificaContent":"{\"createDate\":1536031940000,\"notice\":\"消息\",\"publishName\":\"龙湖物业服务集团有限公司\",\"publishUserName\":\"李俊毓\",\"urgency\":false}","redirectUrl":"https://qaskyline.jianyewy.com/qdp-skyline-web/notice/noticesenddetail.do?noticeId=","notificaStatus":0}];
      });

      // 客服弹框
      axios.get('/property/ajax/getComPanyByCompanyId', { // 是否开通在线客服
        params: {tenementId: this.$store.state.user.tenementId},
        cache: false,
        global: false
      }).then(res => {
        if (res.data&&res.data.useOnlineCustomer&&res.data.useOnlineCustomer==1) {
          (function(m, ei, q, i, a, j, s) {
            m[i] =
              m[i] ||
              function() {
                (m[i].a = m[i].a || []).push(arguments);
              };
            (j = ei.createElement(q)), (s = ei.getElementsByTagName(q)[0]);
            j.async = true;
            j.charset = 'UTF-8';
            j.src = 'https://static.meiqia.com/dist/meiqia.js?_=t';
            s.parentNode.insertBefore(j, s);
          })(window, document, 'script', '_MEIQIA');
          _MEIQIA('entId', 56684);
          _MEIQIA('metadata', {
            name: this.$store.state.user.realName,
            "账号": this.$store.state.user.id,
            "说明": 'SaaS Web'
          });
          _MEIQIA('clientId', this.$store.state.user.id);
        } else {
          // 没开通在线客服
        }
        // 同时：首次调用 查看是否开通物业号(返回用户自定义数据)
        if(res.code===200){
          if(res.data.homePageAddress===null){
            localStorage.setItem('homePageAddress','');
            localStorage.setItem('homePageAddressTitle','');
            localStorage.setItem('homePageAddressId','');
          }
          else{
            let urlArr=res.data.homePageAddress.split(/\?/);
            let queryArr=urlArr[1].split('&');
            let homePageAddress=urlArr[0];
            let homePageAddressTitle=queryArr[0].slice(queryArr[0].indexOf('=')+1);
            let homePageAddressId=queryArr[1].slice(queryArr[1].indexOf('=')+1);
             localStorage.setItem('homePageAddress',homePageAddress);
             localStorage.setItem('homePageAddressTitle',homePageAddressTitle);
             localStorage.setItem('homePageAddressId',homePageAddressId);
          }
          localStorage.setItem('homePageAddress',res.data.homePageAddress===null?'':res.data.homePageAddress);//首页地址
          localStorage.setItem('loginAddress',res.data.loginAddress===null?'':res.data.loginAddress);//第三方登录页地址
          localStorage.setItem('logoAddress',res.data.logoAddress===null?'':res.data.logoAddress);//logo地址
          localStorage.setItem('isServiceUpgrade',res.data.isServiceUpgrade===null?'':res.data.isServiceUpgrade);//是否支持升级
           // 定义用户配置logo/是否升级
          localStorage.getItem('logoAddress')?this.logoUrl=localStorage.getItem('logoAddress'):void(0);
          // this.isShowUpgrade=localStorage.getItem('isServiceUpgrade')!='0';
          // 非网关重定向进入页面校验（第三方账号需跳转至第三方登录页面去重走第三方登录流程）
          if(!this.isFromGW){
            // 非网关直接重定向
            if(localStorage.getItem('loginAddress')&&(localStorage.getItem('source')=='gateway')){
              // 第三方接入账号
              window.top.location.href=localStorage.getItem('loginAddress');
            }
            else{
              //千丁云账号
            }
          }
          // 根据配置打开自定义页面
          if(localStorage.getItem('homePageAddress')){
            if(localStorage.getItem('homePageAddress').indexOf('#')!=-1){
              // iframe 嵌入的第三方页面
              this.$nextTick(()=>{
                window.top.long.openPage(localStorage.getItem('homePageAddressId'),localStorage.getItem('homePageAddressTitle'),localStorage.getItem('homePageAddress'));
              })
            }
            else{
              // 千丁云页面
              let saasUrl=localStorage.getItem('homePageAddress').slice(localStorage.getItem('homePageAddress').indexOf('/',10))
              window.top.long.openSaasPage(localStorage.getItem('homePageAddressId'),localStorage.getItem('homePageAddressTitle'),saasUrl);
            }
          }
        }
      });
    }
    // 重写子iframe方法
    let _this = this;
    let long = window.long = {};
    long.open_page = long.openPage = function (mid, text, url) {
      // 设置同域（？看起来似乎只是变更了协议）
      let urlHeader = location.protocol;
      let urls = url.split("/");
      if (urls && urls.length>0 && urls[0]!=urlHeader) {
        url = url.replace(urls[0], urlHeader);
      }
      // 标签
      let flag = false;
      for (let i = 0; i < _this.tabslist.length; i++) {
        if (_this.tabslist[i].name == mid) {
          flag = true;
          break;
        }
      }
      if (flag) {
        _this.tabValue = mid;
        sessionStorage.setItem('tabsList', JSON.stringify(_this.tabslist));
        sessionStorage.setItem('tabIndex', mid);
      } else {
        _this.tabslist.push({
          title: text,
          name: mid,
          url: url,
          isSkyLine: true,
          tabId: mid
        });
        _this.tabValue = mid;
        sessionStorage.setItem('tabsList', JSON.stringify(_this.tabslist));
        sessionStorage.setItem('tabIndex', mid);
      }
      _this.setFrontUrl(url);
      _this.$router.push('/skyline');
    }
    console.log(location.protocol);
    long.pageContentPaddingNone = function (mid) {}
    long.setIframeHeight = function (iframe){}
    long.set_iframe_height = function (name, val) {}
    long.currentIframe = function(){
      return {
        css: function(json){
          if (json && _this.tabValue && document.getElementById(_this.tabValue)) {
            document.getElementById(_this.tabValue).style.height = json.height;
            document.getElementById(_this.tabValue).style['min-height'] = json['min-height'];
          }
        }
      }
    };
    // 20190215 iframe的content的上下留白
    long.currentContent = function(){
      return {
        css: function(json){
          if (json && _this.tabValue && document.getElementById(_this.tabValue) && document.getElementById(_this.tabValue).parentNode) {
            document.getElementById(_this.tabValue).parentNode.style.top = (json.top + 100) + 'px';
            document.getElementById(_this.tabValue).parentNode.style.bottom = (json.bottom) + 'px';
          }
        }
      }
    };
    // 20190213 修改样式方法
    long.changeIframeOverflow = function(overflow){
      if (overflow && _this.tabValue && document.getElementById(_this.tabValue)) {
        document.getElementById(_this.tabValue).style.overflow = overflow;
        if(document.getElementById(_this.tabValue).parentNode){
          document.getElementById(_this.tabValue).parentNode.style.overflow = overflow;
        }
      }
    };
    // long 关闭标签
    long.close_page = function (mid) {
      let tabs = _this.tabslist;
      let activeName = _this.tabValue;
      if (activeName === mid) {
        tabs.forEach((tab, index) => {
          if (tab.name === mid) {
            let nextTab = tabs[index - 1] || tabs[index + 1];
            if (nextTab) {
              activeName = nextTab.name;
              if (nextTab.url.match(/b\.jianyewy\.com/) || !nextTab.url.match(/\/\//)) {
                _this.$router.push(nextTab.url);
              } else {
                // 设置同域
                let urlHeader = location.protocol;
                let frontUrl = nextTab.url;
                let urls = frontUrl.split("/");
                if (urls && urls.length>0 && urls[0]!=urlHeader) {
                  frontUrl = frontUrl.replace(urls[0], urlHeader);
                }
                _this.setFrontUrl(frontUrl);
                _this.$router.push('/skyline');
              }
              _this.menuActive = (nextTab.tabId+'').substr(2);
            } else {
              _this.selectList = _this.currentList = (_this.menuLs&&_this.menuLs.length>0)?_this.menuLs[0].subMenuList:[] || [];
              sessionStorage.setItem('curMenuIndex', -1);
              sessionStorage.setItem('menuActive', '');
              _this.menuActive = '';
              _this.currentIndex = -1;
              if (_this.isService) {
                activeName = 'shouye';
                _this.$router.push('/home'); // 20190121 域名/ 不对应首页，加一级
              } else {
                activeName = 'shouye1';
                _this.$router.push('/thome/5');
              }
            }
          }
        });
      }
      _this.tabValue = activeName;
      _this.tabslist = tabs.filter(tab => tab.name !== mid);
      sessionStorage.setItem('tabsList', JSON.stringify(_this.tabslist));
      sessionStorage.setItem('tabIndex', activeName+'');
    }
    long.openSaasPage = function (mid, text, url) {
      // 设置同域
      // 标签
      let flag = false;
      for (let i = 0; i < _this.tabslist.length; i++) {
        if (_this.tabslist[i].name == mid) {
          flag = true;
          break;
        }
      }
      if (flag) {
        _this.tabValue = mid;
        sessionStorage.setItem('tabsList', JSON.stringify(_this.tabslist));
        sessionStorage.setItem('tabIndex', mid);
      } else {
        _this.tabslist.push({
          title: text,
          name:  mid,
          url: url,
          isSkyLine: false,
          tabId: mid
        });
        _this.tabValue = mid;
        sessionStorage.setItem('tabsList', JSON.stringify(_this.tabslist));
        sessionStorage.setItem('tabIndex', mid);
      }
      _this.$router.push(url);
    }
    long.changeSaasRouter = function (oldRouter, newRouter, newName, flag=false) {
      for (let i = 0; i < _this.tabslist.length; i++) {
        if (_this.tabslist[i].url == oldRouter) {
          // include 替换 删除
          _this.includeArr.push(newName);
            console.log(_this.includeArr);
          if (flag) {
            let list = _this.includeArr;
            _this.includeArr = list.filter(tab => tab !== _this.tabslist[i].routeName);
            // _this.includeArr.push(newName);
            console.log(_this.includeArr);
          }
          _this.tabslist[i].url = newRouter;
          _this.tabslist[i].routeName = newName;
          sessionStorage.setItem('tabsList', JSON.stringify(_this.tabslist));
          // 
          console.log(newName);
          // _this.includeArr.push(newName);
          return;
        }
      }
    }
    // iframe layer 提示框
    let layer = window.long.layer = window.layer = {};
    layer.msg = function(msg,data) {
      if (data) {
        if (data.icon == 7) {
          Message({
            type: 'warning',
            message: msg
          });
        } else if (data.icon == 2) {
          Message({
            type: 'error',
            message: msg
          });
        } else {
          Message({
            type: 'success',
            message: msg
          });
        }
      }
    }
    layer.alert = function(msg) {
      _this.$alert(msg, '提示框', {
        confirmButtonText: '确定',
        callback: action => {}
      });
    }
    long.pageContentPaddingNone = function(mid) {};

    if (location.pathname == '/') {
    } else {
    this.getPromotionImg({
      imgType: '03'
    }).then(data => {
      data.data.bigImageUrl && (this.promotion = data.data);
    });

    this.getAuth();
    this.$nextTick(function() {});

    this.isService = sessionStorage.getItem('isService') == "false"?false:true || true;
    this.changeMenusList(false);

    let tabs = sessionStorage.getItem('tabsList');
    this.tabslist = tabs?JSON.parse(tabs): [];
    this.tabValue = sessionStorage.getItem('tabIndex');
    // if(this.tabslist.length==0){
    //   let url = sessionStorage.getItem('isService') == "false"?'/thome/5':'/' || '/';
    //   this.tabslist = [{ title: '首页', name: 'shouye',url: url}];
    // }
    if(this.tabValue==''){
      let tab = sessionStorage.getItem('isService') == "false"?'shouye1':'shouye' || 'shouye';
      this.tabValue = tab;
    }

    }
  },
  // created: function () {
  //     setInterval(this.getTipList, 5*60*1000);
  // },
  filters: {
    dateFormat: function(date, fmt) {
      return Filter.date(date || '', fmt);
    }
  },
  methods: {
    ...mapActions(['menuList', 'getPromotionImg', 'getAuth', 'getNotices', 'readNotifica', 'checkAccount', 'getNoticesDlg']),
    ...mapMutations(['setFrontUrl']),
    changeCollapse() {
      this.isCollapse = !this.isCollapse;
      this.hot = !this.hot;
      this.isCollapse && (this.hotclass = 'hot');
      !this.isCollapse && (this.hotclass = 'hot hot-ncollapse');
    },
    closePromotion() {
      this.promotion = null;
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    loginOut() {
      axios
        .post(
          '/account/ajax/logout',
          {
            params: {}
          },
          {
            global: false
          }
        )
        .then(data => {
          if (data.code == 200) {
            localStorage.removeItem('user');
            sessionStorage.removeItem('wxAppId');
            sessionStorage.setItem('isService', '');
            sessionStorage.setItem('tabsList', []);
            sessionStorage.setItem('tabIndex', '');
            sessionStorage.setItem('menuActive', '');
            // location.href = '/account/login?url=' + location.href;
            if(localStorage.getItem('loginAddress')&&(localStorage.getItem('source')=='gateway')){
              window.top.location.href=localStorage.getItem('loginAddress')+'?from=logout';
            }
            else{
              location.href = '/account/login';
            }
          }
        });
    },
    //跟着别人插件走  逻辑一坨
    menuSearch() {
      let list = this.clone(this.allTwoList);
      this.menuActive = '';
      let active = false;
      const help = (obj, value) => {
        if (obj instanceof Array) {
          let l = obj.length;
          for (let i = 0; i < l; i++) {
            if (obj.noshow === false) continue;
            let o = help(obj[i], value);
            if (o.noshow === false && o.hierarchy !== 2) {
              obj.noshow = o.noshow;
            }
            if (active) continue;
            if (o.hierarchy == 2 && o.noshow === false) {
              active = true;
              this.menuActive = i + 1 + '-' + this.menuActive;
            } else if (o.noshow === false) {
              this.menuActive = i + 1 + (this.menuActive ? '-' + this.menuActive : this.menuActive);
            }
          }
        } else if (obj instanceof Object) {
          if (value && obj.name.indexOf(value) !== -1) {
            obj.noshow = false;
          } else {
            obj.noshow = true;
          }
          if (obj.subMenuList && obj.subMenuList.length > 0) {
            let o = help(obj.subMenuList, value);
            if (o.noshow === false) {
              obj.noshow = o.noshow;
            }
          }
        }
        return obj;
      };
      if (this.search) {
        this.currentList = help(list, this.search);
      } else {
        this.currentList = this.selectList;
      }
    },
    // 这个方法待优化
    clone(obj) {
      var buf;
      if (obj instanceof Array) {
        buf = [];
        var i = obj.length;
        while (i--) {
          buf[i] = this.clone(obj[i]);
        }
        return buf;
      } else if (obj instanceof Object) {
        buf = {};
        for (var k in obj) {
          buf[k] = this.clone(obj[k]);
        }
        return buf;
      } else {
        return obj;
      }
    },
    topMenuClick(item, index) {
      this.selectList = this.currentList = item.subMenuList || [];
      sessionStorage.setItem('curMenuIndex', index);
      sessionStorage.setItem('menuActive', '');
      // 解决关闭标签高亮还存在
      this.menuActive = '-1';
      this.$nextTick(()=>(this.menuActive = ''));
      this.currentIndex = index;
      // this.$router.push(item.frontUrl);
    },
    topMenuClickHome(index) {
      this.selectList = this.currentList = (this.menuLs&&this.menuLs.length>0)?this.menuLs[0].subMenuList:[] || [];
      sessionStorage.setItem('curMenuIndex', index);
      sessionStorage.setItem('menuActive', '');
      // 解决关闭标签高亮还存在
      this.menuActive = '-1';
      this.$nextTick(()=>(this.menuActive = ''));
      this.currentIndex = index;
      if (this.isService) {
        this.tabValue = 'shouye';
        this.$router.push('/home'); // 20190121 域名/ 不对应首页，加一级
      } else {
        this.tabValue = 'shouye1';
        this.$router.push('/thome/5');
      }
      sessionStorage.setItem('tabIndex', this.tabValue);
    },
    handlehideNotice() {
      document.querySelector('.dropdown-menu').style.display = 'none';
      this.isShowNotice = false;
    },
    handleShowNotice(event) {
      this.getNotices({
        page: 1,
        size: 1000,
        status: 0
      }).then(res => {
        if (res.data && res.data.entity && res.data.entity.data) {
          this.tipNum = res.data.entity.data.length;
          this.noticeList = res.data.entity.data;
        } else {
          this.tipNum = 0;
          this.noticeList = [];
        }
        this.$refs['dropdownMenu'].style.display = 'block';
        this.isShowNotice = true;
        this.stopBubble(event);
      });

      document.onclick = function() {
        document.querySelector('.dropdown-menu').style.display = 'none';
        this.isShowNotice = false;
        document.onclick = null;
      };
    },
    //阻止冒泡函数
    stopBubble(e) {
      console.log('stop');
      if (e && e.stopPropagation) {
        e.stopPropagation(); //w3c
      } else {
        window.event.cancelBubble = true; //IE
      }
    },
    getTipList() {
      this.getNotices({
        page: 1,
        size: 1000,
        status: 0
      }).then(res => {
        if (res.data && res.data.entity && res.data.entity.data) {
          this.tipNum = res.data.entity.data.length;
          this.noticeList = res.data.entity.data;
        } else {
          this.tipNum = 0;
          this.noticeList = [];
        }
      });
    },
    noticesClick(item) {
      if (!item.redirectUrl) return;
      if (item.redirectUrl.match(/b\.jianyewy\.com/) || !item.redirectUrl.match(/\/\//)) {
        // 标签
        let flag = false;
        for (let i = 0; i < this.tabslist.length; i++) {
          if (this.tabslist[i].name == item.id) {
            flag = true;
            break;
          }
        }
        if (flag) {
          this.tabValue = item.id;
          sessionStorage.setItem('tabsList', JSON.stringify(this.tabslist));
          sessionStorage.setItem('tabIndex', item.id);
        } else {
          this.tabslist.push({
            title: '公告列表',
            name:  item.id,
            url: item.redirectUrl,
            isSkyLine: false,
            tabId: item.id
          });
          this.tabValue = item.id;
          sessionStorage.setItem('tabsList', JSON.stringify(this.tabslist));
          sessionStorage.setItem('tabIndex', item.id);
        }

        this.$router.push(item.redirectUrl);
      } else {
        // 设置公告已读状态 todo
        this.readNotifica({ params: { notificaId: item.id } }).then(res => res);
        // 设置同域
        let urlHeader = location.protocol;
        let frontUrl = item.redirectUrl;
        let urls = frontUrl.split("/");
        if (urls && urls.length>0 && urls[0]!=urlHeader) {
          frontUrl = frontUrl.replace(urls[0], urlHeader);
        }

        // 标签
        let flag = false;
        for (let i = 0; i < this.tabslist.length; i++) {
          if (this.tabslist[i].name == item.id) {
            flag = true;
            break;
          }
        }
        if (flag) {
          this.tabValue = item.id;
          sessionStorage.setItem('tabsList', JSON.stringify(this.tabslist));
          sessionStorage.setItem('tabIndex', item.id);
        } else {
          this.tabslist.push({
            title: '公告列表',
            name: item.id,
            url: frontUrl + item.referId,
            isSkyLine: true,
            tabId: item.id
          });
          this.tabValue = item.id;
          sessionStorage.setItem('tabsList', JSON.stringify(this.tabslist));
          sessionStorage.setItem('tabIndex', item.id);
        }


        this.setFrontUrl(frontUrl + item.referId);
        // this.setFrontUrl(item.redirectUrl + item.referId);
        this.$router.push('/skyline');
      }
      document.querySelector('.dropdown-menu').style.display = 'none';
      this.isShowNotice = false;
      if (this.tipNum > 0) {
        this.tipNum = this.tipNum - 1;
      }
    },
    noticesAll() {
      document.domain = 'jianyewy.com';
      //打开一个菜单
      // long.open_page = long.openPage = function(mid, text, url) {
      //   if (document.getElementById('saasIframe')) {
      //     document.getElementById('saasIframe').src = url;
      //   }
      //   // 标签
      //   let flag = false;
      //   for (let i = 0; i < this.tabslist.length; i++) {
      //     if (this.tabslist[i].name == mid) {
      //       flag = true;
      //       break;
      //     }
      //   }
      //   if (flag) {
      //     this.tabValue = mid;
      //     sessionStorage.setItem('tabsList', JSON.stringify(this.tabslist));
      //     sessionStorage.setItem('tabIndex', mid);
      //   } else {
      //     // 设置同域
      //     let urlHeader = location.protocol;
      //     // let frontUrl = item.redirectUrl;
      //     let urls = whost.split("/");
      //     if (urls && urls.length>0 && urls[0]!=urlHeader) {
      //       url = whost.replace(urls[0], urlHeader);
      //     }
      //     this.tabslist.push({
      //       title: text,
      //       name: mid,
      //       url: url,
      //       isSkyLine: true
      //     });
      //     this.tabValue = mid;
      //     sessionStorage.setItem('tabsList', JSON.stringify(this.tabslist));
      //     sessionStorage.setItem('tabIndex', mid);
      //     this.$router.push('/skyline/'+mid);
      //   }
      // };

      // let whost = 'https://skyline.jianyewy.com/qdp-nc-web/notification/list.do';
      let whost = 'http://zh.jianyewy.com/qdp-nc-web/notification/list.do';
      axios.post('/account/ajax/wxhost', { params: {} }, { global: false }).then(data => {
        if (data.code == 200 && data.host !== 'https://wx-api.jianyewy.com') {
          // whost = 'https://qaskyline.jianyewy.com/qdp-nc-web/notification/list.do';
          whost = 'http://qazh.jianyewy.com/qdp-nc-web/notification/list.do';
        }
        console.info(whost);
        // this.setFrontUrl(whost);

        // 设置同域
        let urlHeader = location.protocol;
        // let frontUrl = item.redirectUrl;
        let urls = whost.split("/");
        if (urls && urls.length>0 && urls[0]!=urlHeader) {
          whost = whost.replace(urls[0], urlHeader);
        }

        // if (document.getElementById('saasIframe')) {
        //   document.getElementById('saasIframe').src = whost;
        // } else {
          this.setFrontUrl(whost);
        // }
        // 标签
        let midAll = 'noticeall';
        let textAll = '公告列表';
        let flag = false;
        for (let i = 0; i < this.tabslist.length; i++) {
          if (this.tabslist[i].name == midAll) {
            flag = true;
            break;
          }
        }
        if (flag) {
          this.tabValue = midAll;
          sessionStorage.setItem('tabsList', JSON.stringify(this.tabslist));
          sessionStorage.setItem('tabIndex', midAll);
        } else {
          this.tabslist.push({
            title: textAll,
            name: midAll,
            url: whost,
            isSkyLine: true,
            tabId: midAll
          });
          this.tabValue = midAll;
          sessionStorage.setItem('tabsList', JSON.stringify(this.tabslist));
          sessionStorage.setItem('tabIndex', midAll);
        }
        this.$router.push('/skyline');
        document.querySelector('.dropdown-menu').style.display = 'none';
        this.isShowNotice = false;
      });
    },
    handleChangeMenus() {
      this.isService = !this.isService;
      sessionStorage.setItem('isService', this.isService);
      this.changeMenusList(true);
      if (this.isService) {
        this.tabValue = 'shouye';
        this.tabslist = [];
        sessionStorage.setItem('tabsList', JSON.stringify(this.tabslist));
        sessionStorage.setItem('tabIndex', this.tabValue);
        this.$router.push('/home'); // 20190121 域名/ 不对应首页，加一级
      } else {
        this.tabValue = 'shouye1';
        this.tabslist = [];
        sessionStorage.setItem('tabsList', JSON.stringify(this.tabslist));
        sessionStorage.setItem('tabIndex', this.tabValue);
        this.$router.push('/thome/5');
      }
    },
    changeMenusList(isSwitch) {
      if (location.pathname.match(/^\/account/)) {
        document.querySelector('.saas-menu').style.display = 'none';
        document.querySelector('.saas-tree').style.display = 'none';
        document.querySelector('.saas-tabs').style.display = 'none'; 
      } else {
        if (this.isService) {
          let userData=JSON.parse(localStorage.getItem('user'));
          this.menuList({menuType: 'S',accountId:userData.id}).then(data => {
            let menulist = data.data.treeMenuList;
            this.headerMenus = data.data.topMenuList;
            this.menuLs = data.data.treeMenuList;
            let list = [];
            for (let i = 0; i < menulist.length; i++) {
              menulist[i].subMenuList && list.push(...menulist[i].subMenuList);
            }
            this.allTwoList = list;
            let index = isSwitch? -1: (sessionStorage.getItem('curMenuIndex') || -1);
            this.currentIndex = index;
            this.selectList = this.currentList = menulist.length > 0 ? (index>-1?menulist[index].subMenuList:menulist[0].subMenuList) : [];
            this.menuActive = isSwitch? '' : (sessionStorage.getItem('menuActive') || '');
          });
        } else {
          // 旧 静态数据
          // this.menuLs = menus.data;
          // let list = [];
          // for (let i = 0; i < menus.data.length; i++) {
          //   menus.data[i].subMenuList && list.push(...menus.data[i].subMenuList);
          // }
          // this.allTwoList = list;
          // let index = isSwitch? -1: (sessionStorage.getItem('curMenuIndex') || -1);
          // this.currentIndex = index;
          // this.selectList = this.currentList = menus.data.length > 0 ? (index>-1?menus.data[index].subMenuList:menus.data[0].subMenuList) : [];
          // this.menuActive = isSwitch? '' : (sessionStorage.getItem('menuActive') || '');
          let userData=JSON.parse(localStorage.getItem('user'));
          this.menuList({menuType: 'B',accountId:userData.id}).then(data => {
            let menulist = data.data.treeMenuList;
            this.headerMenus = data.data.topMenuList;
            this.menuLs = menulist;
            let list = [];
            for (let i = 0; i < menulist.length; i++) {
              menulist[i].subMenuList && list.push(...menulist[i].subMenuList);
            }
            this.allTwoList = list;
            let index = isSwitch? -1: (sessionStorage.getItem('curMenuIndex') || -1);
            this.currentIndex = index;
            this.selectList = this.currentList = menulist.length > 0 ? (index>-1?menulist[index].subMenuList:menulist[0].subMenuList) : [];
            this.menuActive = isSwitch? '' : (sessionStorage.getItem('menuActive') || '');
          });
        }
      }
    },
    removeTab(targetName) {
      // 验证登录状态 2019-01-28
      this.checkIsLogin();
      
      let tabs = this.tabslist;
      // let activeName = this.menuActive;
      let activeName = this.tabValue; //(sessionStorage.getItem('curMenuIndex')?(sessionStorage.getItem('curMenuIndex')==-1?'0':sessionStorage.getItem('curMenuIndex')):'0') + '-' + this.menuActive;
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            let nextTab = tabs[index - 1] || tabs[index + 1];
            if (nextTab) {
              activeName = nextTab.name;

              if (nextTab.url.match(/b\.jianyewy\.com/) || !nextTab.url.match(/\/\//)) {
                this.$router.push(nextTab.url);
              } else {
                // 设置同域
                let urlHeader = location.protocol;
                let frontUrl = nextTab.url;
                let urls = frontUrl.split("/");
                if (urls && urls.length>0 && urls[0]!=urlHeader) {
                  frontUrl = frontUrl.replace(urls[0], urlHeader);
                }
                
                this.setFrontUrl(frontUrl);
                this.$router.push('/skyline');
              }
              // this.menuActive = (nextTab.tabId+'').substr(2);
              let tabAry = (nextTab.tabId+'').split('-');
              if (tabAry && tabAry.length>0) {
                let ind = tabAry[0];
                if (tabAry[0]=='0' && this.currentIndex=='-1') {
                  ind = -1;
                }
                this.currentIndex = ind;
                this.index = ind;
                this.selectList = this.currentList = (this.menuLs&&this.menuLs.length>0)&&this.menuLs[tabAry[0]]?this.menuLs[tabAry[0]].subMenuList:this.selectList || this.selectList;
                sessionStorage.setItem('curMenuIndex', ind);
                this.menuActive = (nextTab.tabId+'').substr(tabAry[0].length+1);
                sessionStorage.setItem('menuActive', (nextTab.tabId+'').substr(tabAry[0].length+1));
              }
            } else {
              this.selectList = this.currentList = (this.menuLs&&this.menuLs.length>0)?this.menuLs[0].subMenuList:[] || [];
              sessionStorage.setItem('curMenuIndex', -1);
              sessionStorage.setItem('menuActive', '');
              this.currentIndex = -1;
              if (this.isService) {
                activeName = 'shouye';
                this.$router.push('/home'); // 20190121 域名/ 不对应首页，加一级
              } else {
                activeName = 'shouye1';
                this.$router.push('/thome/5');
              }
              // 解决关闭标签高亮还存在
              this.menuActive = '-1';
              this.$nextTick(()=>(this.menuActive = ''));
            }
          }
        });
      }
      
      this.tabValue = activeName;
      this.tabslist = tabs.filter(tab => tab.name !== targetName);

      sessionStorage.setItem('tabsList', JSON.stringify(this.tabslist));
      sessionStorage.setItem('tabIndex', activeName+'');
    }, 
    clickTab(item) {
      // 验证登录状态 2019-01-28
      this.checkIsLogin();
      if(item.name=='shouye' || item.name=='shouye1'){
        this.currentIndex = this.index = -1;
        this.selectList = this.currentList = (this.menuLs&&this.menuLs.length>0)?this.menuLs[0].subMenuList:[] || [];
        sessionStorage.setItem('curMenuIndex', -1);
        // 解决关闭标签高亮还存在
        this.menuActive = '-1';
        this.$nextTick(()=>(this.menuActive = ''));
        sessionStorage.setItem('menuActive', '');
        if (this.isService) {
          this.tabValue = 'shouye';
          this.$router.push('/home'); // 20190121 域名/ 不对应首页，加一级
        } else {
          this.tabValue = 'shouye1';
          this.$router.push('/thome/5');
        }
        sessionStorage.setItem('tabIndex', this.tabValue);
        return;
      }
      let tabs = this.tabslist;
      let activeName = this.menuActive;
      tabs.forEach((tab, index) => {
        if (tab.name === item.name) {
          activeName = tab.tabId;
          if (tab.url.match(/b\.jianyewy\.com/) || !tab.url.match(/\/\//)) {
            this.$router.push(tab.url);
          } else {
            // 设置同域
            let urlHeader = location.protocol;
            let frontUrl = tab.url;
            let urls = frontUrl.split("/");
            if (urls && urls.length>0 && urls[0]!=urlHeader) {
              frontUrl = frontUrl.replace(urls[0], urlHeader);
            }
            this.setFrontUrl(frontUrl);
            this.$router.push('/skyline');
          }
        }
      });
      let tabAry = (activeName+'').split('-');
      if (tabAry && tabAry.length>0) {
        let ind = tabAry[0];
        if (tabAry[0]=='0' && this.currentIndex=='-1') {
          ind = -1;
        }
        this.currentIndex = ind;
        this.index = ind;
        this.selectList = this.currentList = (this.menuLs&&this.menuLs.length>0)&&this.menuLs[tabAry[0]]?this.menuLs[tabAry[0]].subMenuList:this.selectList || this.selectList;
        sessionStorage.setItem('curMenuIndex', ind);
        this.menuActive = (activeName+'').substr(tabAry[0].length+1);
        sessionStorage.setItem('menuActive', (activeName+'').substr(tabAry[0].length+1));
      }
      // this.menuActive = (this.tabValue+'').substr(2);
      // sessionStorage.setItem('menuActive', (this.tabValue+'').substr(2));
      sessionStorage.setItem('tabsList', JSON.stringify(this.tabslist));
      sessionStorage.setItem('tabIndex', this.tabValue);
    },
    closeAll() { // 关闭全部
      // 验证登录状态 2019-01-28
      this.checkIsLogin();

      this.tabslist = [];
      this.tabValue = '';
      sessionStorage.setItem('tabsList', JSON.stringify(this.tabslist));
      sessionStorage.setItem('tabIndex', '');
      // if (this.isService) {
      //   this.tabValue = 'shouye';
      //   this.$router.push('/');
      // } else {
      //   this.tabValue = 'shouye1';
      //   this.$router.push('/thome/5');
      // }
      this.topMenuClickHome(-1);
      // 解决关闭标签高亮还存在
      this.menuActive = '-1';
      this.$nextTick(()=>(this.menuActive = ''));
    },
    reload () {
     this.isRouterAlive = false;
     this.$nextTick(() => (this.isRouterAlive = true));
    },
    reloadRouter(routerName) {
      let tabs = this.includeArr;
      this.includeArr = tabs.filter(tab => tab !== routerName);

      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true,
        this.includeArr.push(routerName)
      });
    },
    repush(item) { // 刷新当前页面
      // 验证登录状态 2019-01-28
      this.checkIsLogin();
      
      if (item) {
        let tabs = this.tabslist;
        tabs.forEach((tab, index) => {
          if (tab.name === item) {
            if (tab.isSkyLine) {
              // document.getElementById(tab.name).src=tab.url
              if(document.getElementById(tab.name)) {
                document.getElementById(tab.name).contentWindow.location.reload(true);
              }
            } else {
              this.reloadRouter(tab.routeName);
            }
          }
        });
      }
    },
    closeOther() { // 关闭其他
      // 验证登录状态 2019-01-28
      this.checkIsLogin();
      
      let tabs = this.tabslist;
      let tabValue = this.tabValue;
      let tabOne = null;
      tabs.forEach((tab, index) => {
        if (tab.name === tabValue) {
          tabOne = tab;
        }
      });
      this.tabslist = [];
      if(tabOne) {
        this.tabslist.push(tabOne);
      }

      sessionStorage.setItem('tabsList', JSON.stringify(this.tabslist));
    },
    updPaw() {
      // 验证登录状态
      this.checkIsLogin();
      // 标签
      let mid = 'updatePassword';
      let text = '修改密码';
      let url = '/updatepassword';
      this.addNewTabs(mid, text, url);
      this.topmenuVis = false;
    },
    clickTopMenu: function(item) {
      // 验证登录状态
      this.checkIsLogin();
      // 标签
      let mid = item.id;
      let text = item.name;
      let url = item.frontUrl;
      this.addNewTabs(mid, text, url);
      this.topmenuVis = false;
    },
    checkIsLogin: function() { // 调用接口验证是否登录
      // 验证登录状态--
      let result = this.checkAccount({ mchId: this.$store.state.user.tenementId });
      if ( result.code == 403 ) {
        return;
      }
    },
    addNewTabs: function(mid, text, url) { // 增加新页签（左上角链接）
      let flag = false;
      for (let i = 0; i < this.tabslist.length; i++) {
        if (this.tabslist[i].name == mid) {
          flag = true;
          break;
        }
      }
      this.currentIndex = '-2';
      sessionStorage.setItem('curMenuIndex', '');
      // 解决关闭标签高亮还存在
      this.menuActive = '-1';
      this.$nextTick(()=>(this.menuActive = ''));
      sessionStorage.setItem('menuActive', '');
      if (flag) {
        this.tabValue = mid;
        sessionStorage.setItem('tabsList', JSON.stringify(this.tabslist));
        sessionStorage.setItem('tabIndex', mid);
      } else {
        // 判断是否iframe
        if (url.match('http')) {
          // 设置同域
          let urlHeader = location.protocol;
          let urls = url.split("/");
          if (urls && urls.length>0 && urls[0]!=urlHeader) {
            url = url.replace(urls[0], urlHeader);
          }
          this.tabslist.push({
            title: text,
            name: mid,
            url: url,
            isSkyLine: true,
            tabId: mid
          });
          this.tabValue = mid;
          sessionStorage.setItem('tabsList', JSON.stringify(this.tabslist));
          sessionStorage.setItem('tabIndex', mid);
          this.setFrontUrl(url);
          this.$router.push('/skyline');
        } else {
          this.tabslist.push({
            title: text,
            name: mid,
            url: url,
            isSkyLine: false
          });
          this.tabValue = mid;
          sessionStorage.setItem('tabsList', JSON.stringify(this.tabslist));
          sessionStorage.setItem('tabIndex', mid);
          this.$router.push(url);
        }
      }
    },
    noticeAlert: function() {
      this.getNoticesDlg({}).then(data => {
        if (data.data && data.data.id) {
          this.noticeItem = data.data;
          this.noticeVisible = true;
        }
        // this.noticeItem = { // 弹框通知对象
        //   id: '',
        //   title: '',
        //   notice: '',
        //   sendTime: '',
        //   sendOrganName: ''
        // }
      });
    },
    closeAlert: function(id) {
      let _that = this;
      _that.readNotifica({ params: { notificaId: id } }).then(res => {
        //
        _that.noticeVisible = false;
        setTimeout(function(){
          _that.noticeAlert();
        }, 200);
      },rej => {
        _that.noticeVisible = false;
      })
    },
    clickShowMenus: function() {
      this.topmenuVis = !this.topmenuVis;
      document.querySelector('.dropdown-menu').style.display = 'none';
      this.isShowNotice = false;
    },
    handleBodyClick: function() {
      if (this.topmenuVis== true) {
        this.topmenuVis = false;
      }
      document.querySelector('.dropdown-menu').style.display = 'none';
      this.isShowNotice = false;
    },
    handlehideMenus: function() {
      if (this.topmenuVis== true) {
        this.topmenuVis = false;
      }
    }
  },
  components: {
    iframeView
  },
  destroyed () {
    document.removeEventListener('click', this.handleBodyClick)
  }
};
</script>
<style lang="less" module>
#pc_app {
  display: flex;
  min-width: 1310px;
  height: 100%;
  .saas-tree {
    overflow: hidden;
    width: 240px;
    background: #303949; //#323c4d;
    height: 100%;
    .saas-icon {
      height: 120px;
      background: #303949 url(//img1.jianyewy.com/9f52f8ddda0b8d1ce0083589525ce96c.png) center no-repeat;
      background-size: 55px 66px;
    }
    .left-header {
      height: 120px;
      .saas-new-icon {
        // background-image: url(//img1.jianyewy.com/0fe260a79cd9a8e920502d35b4cb16de.png);
        background-color:#303949;
        background-position: center;
        background-repeat: no-repeat; 
        background-size: 115px 29px;
        height: 70px;
      }
      .switch-menu {
        width: 114px;
        height: 30px;
        margin: 0 auto;
        background: rgba(79,158,250,0.20);
        // border: 2px solid #4F9EFA;
        border-radius: 20px;
        font-size: 14px;
        color: #4F9EFA;
        text-align: center;
        line-height: 28px;
        cursor: pointer;
      }
      .switch-menu:before {
        content: "";
        position: absolute;
        left: 63px;
        width: 228px;
        height: 60px;
        border: 3px solid #4F9EFA;
        border-radius: 40px;
        -webkit-transform-origin: 0 0;
        -moz-transform-origin: 0 0;
        -ms-transform-origin: 0 0;
        -o-transform-origin: 0 0;
        transform-origin: 0 0;
        -webkit-transform: scale(0.5, 0.5);
        -ms-transform: scale(0.5, 0.5);
        -o-transform: scale(0.5, 0.5);
        transform: scale(0.5, 0.5);
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
      }
    }
    .saas-menu-search {
      background: #272F3E;
      padding: 14px 23px;
      .el-input {
        width: 100%;
        input {
          height: 30px;
          line-height: 30px;
          background: #303949;
          border: none;
          border-radius: 100px;
          font-size: 12px;
          // color: #EBF1F5;
          color: #FFFFFF;
        }
        input::-webkit-input-placeholder {
          color: #6F7E95; // #9BA3AF;
        }
        input:focus {
          background: #1E242E;
        }
      }
      .el-input__suffix {
        right: 10px;
      }
      .el-input__icon {
        line-height: 35px;
      }
    }
    .hot {
      position: fixed;
      bottom: 0;
      text-align: center;
      height: 100px;
      width: 65px;
      color: #fff;
      background: #212d3b;
      box-shadow: 0 -1px 3px 0 #1d2937;
      .is-hot {
        position: relative;
        img.small {
          margin: 10px auto 0;
          display: block;
          width: 30px;
          height: 50px;
        }
        img.open {
          margin-top: 10px;
          width: 20px;
        }
        p {
          margin-top: 25px;
          font-size: 16px;
          line-height: 1;
        }
      }
      .is-hot2 {
        display: flex;
        div {
          flex: 1;
        }
        img {
          margin: auto;
          width: 200px;
          height: 100px;
        }
        i {
          position: absolute;
          top: 4px;
          right: 4px;
        }
      }
    }
    .hot-ncollapse {
      width: 240px;
    }
    a {
      text-decoration: none;
    }
    ul {
      background: transparent;
    }
    li {
      background: #1E242E;;
      font-size: 14px;
      color: #D8DFE5;
      letter-spacing: 0;
      text-align: left;
    }
    .saas-menu-onetitle.is-opened {
      border-left: 4px solid #4F9EFA;
      background: #1E242E!important;
      color: #d8dfe5!important;
    }
    .is-opened > .el-submenu__title{
      background: #1E242E!important;
      color: #D8DFE5;

        
      // .el-icon-home{
      //   background-position: right;
      // }
    }
    .saas-menu-onetitle.is-opened > .el-submenu__title {
      &:hover {
        border-left: none;
      }
    }
    .saas-menu-onetitle > .el-submenu__title {
      background: #303949;
      &:hover {
        background: #1E242E!important;
        color: #fff;
        // border-left: 4px solid #4F9EFA; 20190128
      }
      span {
        width: 156px;
      }
    }
    .el-submenu__title {
      color: #D8DFE5;
      // background: #303949;
      height: 43px;
      line-height: 43px;
      &:hover {
        background: #365B89;
        // background: rgba( 79, 158, 250, 0.4);
        color: #fff;

        .el-icon-home{
          background-position: right;
        }
        i { // 菜单下拉箭头
          color: #fff;
        }
      }
      .is-active {
        background: rgba( 79, 158, 250, 0.4);
        color: #fff;
      }
      span {
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 156px;
      }
      .el-icon-home{
        margin-right: 5px;
        height: 16px;
        width: 16px;
        vertical-align: middle;
        background-position: left;
        background-size: 32px 16px;
        .iframe-svg {
          border: none;
          height: 16px;
          width: 16px;
          svg {
            color: #D8DFE5;
            stroke: currentColor;
          }
        }
      }
      i { // 菜单下拉箭头
        color: #D8DFE5;
      }
    }
    .el-menu-item {
      span {
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 138px;
      }
    }
    .menu-one-content.el-menu-item {
      span {
        width: 176px;
      }
      .el-icon-home{
        margin-right: -2px;
      }
    }
    .menu-two-content.el-menu-item {
      padding-left: 46px!important;// 20190128
      span {
        width: 156px;
      }
    }
    // .saas-menu-onetitle .el-submenu__title {
    //   background: #303949;
    //   // color: #4f9efa;
    //   color: #6f7e95;
    //   .el-submenu__icon-arrow {
    //     // display: none;
    //   }
    //   &:hover {
    //     background: #365B89;
    //     // background: rgba( 79, 158, 250, 0.4);
    //     color: #fff;
    //   }
    // }
    .el-menu-item.is-disabled {
      opacity: 0.8;
    }
    .el-menu-item {
      height: 43px;
      line-height: 43px;
      &:hover {
        // background: #2a3241;
        color: #fff;
        background: rgba( 79, 158, 250, 0.4);
      }
    }
    .el-menu-item.saas-menu-one {
      background: #303949;
      &:hover {
        // border-left: 4px solid #4F9EFA; 20190128
        background: #1E242E;
        color: #fff;

        .el-icon-home{
          background-position: right;
        }
      }

      .el-icon-home{
        margin-right: 10px;
        margin-left: 20px;
        height: 16px;
        width: 16px;
        vertical-align: middle;
        background-position: left;
        background-size: 32px 16px;
      }
    }

    .el-menu-item.saas-menu-one.is-active {
      .el-icon-home{
        background-position: right;
      }
    }
    
    .el-menu-item-group__title {
      padding: 0;
    }
    .is-active {
      // background: #2a3241;
      background: #4F9EFA !important;
      color: #fff;
    }
    .el-submenu.is-active {
      background: none;
    }
  }
  .saas-content {
    position: relative;
    flex: 1;
    height: 100%;
    overflow: hidden;
    .bgc1 {
      background: #303949;
      div {
        // border-left: 1px solid #29313e;
      }
    }
    .bgc2 {
      background: #FFFFFF;
      border-bottom: 1px solid #EBF1F5;
      div {
        // border-left: 1px solid #EBF1F5;
      }
    }
    .saas-menu {
      height: 60px;
      width: 100%;
      line-height: 60px;
      // overflow: hidden;
      // border: 1px solid #333333;
      // background: #303949;
      color: #a0abbf;
      display: flex;
      .menu-right {
        white-space: nowrap;
        width: 780px;
        height: 60px;
        overflow-x: auto;
        flex: 1;
        div {
          display: inline-block;
          width: auto;
          min-width: 110px;
          text-align: center;
          font-size: 16px;
          // border-left: 1px solid #29313e;
          // .top-icon {
          //   position: relative;
          //   top: -2px;
          //   height: 18px;
          //   vertical-align: middle;
          // }
          .top-icon {
            position: relative;
            top: -2px;
            height: 20px;
            width: 20px;
            min-width: 20px;
            vertical-align: middle;
            background-position: left;
            background-size: 40px 20px;
          }
          cursor: pointer;
          .header-menu:hover {
            color: #fff;
            background: rgba( 79, 158, 250, 0.4);
            .top-icon {
              background-position: right;
              background-size: 40px 20px;
            }
          }
          &.select {
            color: #fff;
            // background: #2a3241;
            background: #4F9EFA;
            .top-icon {
              background-position: right;
              background-size: 40px 20px;
            }
          }
        }
        .header-menu {
          // width: auto;
          border: none;
          padding: 0 10px;
          &:hover {
            color: #fff;
            background: none;
          }
          &.select {
            color: #fff;
            background: none;
          }
        }
      }
      .menu-right::-webkit-scrollbar{
        width: 2px;
        height: 2px;
        background-color: #F5F5F5;
      }
      .menu-right::-webkit-scrollbar-track
      {
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
        border-radius: 10px;
      }
      .menu-right::-webkit-scrollbar-thumb
      {
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
      }
      .clear {
        clear: both;
      }
      .el-col {
        width: 120px;
        text-align: center;
        font-size: 16px;
        border-left: 1px solid #29313e;
        .top-icon {
          position: relative;
          top: -2px;
          height: 18px;
          vertical-align: middle;
        }
        cursor: pointer;
        &:hover,
        &.select {
          img.lingdang {
            content: url('//img1.jianyewy.com/7178e47ca07f4be419be39ea00238610.png');
          }
          span { 
            color: #FFFFFF!important;
          }
        }
        &:hover {
          color: #fff;
          // background: #2a3241;
          background: rgba(79,158,250,0.40);
        }
        &.select {
          color: #fff;
          background: #4F9EFA;
        }
      }
      .grid-item {
        display: flex;
        width: 70px;
        height: 60px;
        align-items: center;
        justify-content: center;
        position: relative;
        .dropdown-toggle {
          width: 100%;
          height: 100%;
          align-items: center;
          justify-content: center;
          position: relative;
          .badge-item {
            position: absolute;
            margin-top: 6px;
            margin-left: -10px;
            .el-badge__content.is-fixed {
              top: 15px;
            }
            .el-badge__content {
              font-size: 10px;
              height: 16px;
              line-height: 16px;
              padding: 0 4px;
              background-color: #E95E90;
              border: 0;
            }
          }
        }

        .dropdown-menu {
          position: absolute;
          right: 0;
          left: auto;
          width: 280px;
          top: 100%;
          cursor: auto;
          z-index: 5555;
          ul {
            width: 100%;
            font-size: 14px;
            text-align: left;
            list-style: none;
            li {
              height: 35px;
              line-height: 20px;
              margin: 0 10px;
              border-bottom: 1px solid #ebf1f5;//#D8DFE5;
              a {
                display: block;
                padding: 7px 10px;
                font-size: 12px;
                color: #6F7E95;
                text-align: center;
                cursor: pointer;
                text-align: left;
                // border-bottom: 1px solid #D8DFE5;
                overflow: hidden;
                text-overflow:ellipsis;
                white-space: nowrap;
              }
              a:hover {
                background-color: #f1f1f1;
              }
            }
          }
          .header {
            margin: 7px 10px;
            border-bottom: 1px solid #ebf1f5;//#D8DFE5;
            font-size: 14px;
            color: #354052;
            height: 25px;
            line-height: 15px;
          }
          .footer {
            height: 35px;
            line-height: 20px;
            margin: 0 10px;
            border-top: 1px solid #ebf1f5;//#D8DFE5;
            a {
              display: block;
              padding: 7px 10px;
              font-size: 14px;
              color: #354052;
              text-align: center;
              cursor: pointer;
            }
          }
          .content {
            position: relative;
            height: 200px;
            width: 100%;
            overflow-y: auto;
          }
          .content::-webkit-scrollbar{
            width: 1px;
            height: 1px;
            background-color: #D8DFE5;
          }
          .content::-webkit-scrollbar-track
          {
            -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
            border-radius: 10px;
          }
          .content::-webkit-scrollbar-thumb
          {
            border-radius: 10px;
            -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
          }
        }
      }
      .el-col.grid-item {
        border-left: 1px solid #29313e; // none;
        border-right: 1px solid #29313e;
      }
      .grid-item1 {
        border-left: 1px solid #EBF1F5!important; //none!important;
        border-right: 1px solid #EBF1F5!important;
        &:hover {
          color: #fff;
          background: rgba( 79, 158, 250, 0.4);
        }
        &.select {
          color: #fff;
          background: #4F9EFA;
        }
      }
      .active {
        background: #47bac1;
      }
      .saas-set {
        // background-image: url(//img1.jianyewy.com/b16ebd3510af2eba3fce5f9e0d53d6d9.png);
        // background-size: 18px;
        // background-position: center;
        // background-repeat: no-repeat;
        &.active {
          /*background-image: url(//img1.jianyewy.com/4b0c10ad52c676590a03ed66331201b5.png);*/
        }
      }
      a,
      a:active {
        color: white;
      }
    }
    .saas-view {
      position: relative;
      height: 100%;
      overflow-y: auto;
      background: #eff4f4;
      padding-bottom: 60px;
      .el-tabs {
        padding: 0;
      }
    }
    .saas-view > div {
      padding-bottom: 60px;
    }
    .saas-tabs {
      width: 100%;
      height: 40px;
      border-bottom: 1px solid #e4e7ed;
      .el-tabs__header {
        margin: 0;
      }
      .tabs-left {
        position: absolute;
        height: 40px;
        width: 100%;
        padding-right: 81px;
        float: left;
        // .el-tabs__nav-next, .el-tabs__nav-prev {
        //   width: 20px;
        //   border-left: 1px solid #e4e7ed;
        //   border-right: 1px solid #e4e7ed;
        // }
      }
      .tabs-menu {
        width: 80px;
        height: 40px;
        line-height: 40px;
        float: right;
        border-left: 1px solid #e4e7ed;
        .el-menu--horizontal>.el-submenu .el-submenu__title {
          height: 39px;
          line-height: 39px;
          border-bottom-color: #fff!important;
        }
      }
      .el-tabs--card>.el-tabs__header {
        border-bottom: none;
      }
      .el-tabs--card>.el-tabs__header .el-tabs__nav {
        border-top: none;
      }
      .el-tabs--card>.el-tabs__header .el-tabs__item {
        border-bottom: none;
      }
      .el-tabs__item {
        color: #9BA3AF;
        span:hover {
          background: #4F9EFA;
        }
      }
      .el-tabs__item.is-active {
        color: #409eff!important;
      }
      .el-tabs__item:hover {
        color: #409eff;
      }
      .el-tabs__nav-wrap.is-scrollable {
        padding: 0 15px;
      }
      .el-tabs__nav-prev {
        border-right: 1px solid #e4e7ed;
        width: 15px;
      }
      .el-tabs__nav-next {
        border-left: 1px solid #e4e7ed;
        width: 15px;
      }
      .el-tabs__item:focus.is-active.is-focus:not(:active) {
        -webkit-box-shadow: none;
        box-shadow: none;
      }
    }
  }
  .el-menu--popup-bottom-start {
    margin-top: 0;
  }
  .menu-out {
    overflow-y: auto;
    height: 100%;
    background: #2a3241;
    // overflow-x: hidden;
  }
  .menu-out::-webkit-scrollbar{
    width: 6px;
    height: 6px;
    background-color: rgba(111,126,149,0.70);
  }
  .menu-out::-webkit-scrollbar-track
  {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 3px;
  }
  .menu-out::-webkit-scrollbar-thumb
  {
    border-radius: 3px;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
  }
  .el-menu-saas {
    background: #323c4d;
    padding-bottom: 170px;
  }
  .el-menu-saas:not(.el-menu--collapse) {
    width: 240px;
  }
  .el-menu-saas {
    border: none;
    transition: 0ms;

    i {
      // background: url(//img1.jianyewy.com/4b0c10ad52c676590a03ed66331201b5.png) no-repeat;
      // /* //img1.jianyewy.com/100a085fcf4928560a8e739250857736.png */
      // background-size: 14px 14px;
      // background-position: center;
      width: 22px;
      height: 22px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .el-submenu__title i {
    width: 11px;
    height: 11px;
  }
  .dropdown-menu {
    z-index: 999;
    display: none;
    background-color: #FFF;
    background-clip: padding-box;
    // border: 1px solid rgba(0, 0, 0, 0.15);
    box-shadow: 0 0 6px 0 rgba(111,126,149,.5);
    border-radius: 4px;
    padding: 5px 0;
    font-size: 14px;
    text-align: left;
    list-style: none;
  }
  .user-header{
    width: 167px!important;
    // padding: 13px 20px!important;
    text-align: left!important;
    justify-content: inherit!important;
    border-left: none!important;
    a {
      padding: 13px 20px!important;
      display: inline-flex!important;
      text-align: left!important;
      justify-content: inherit!important;
      span {
        width: 70px;
        font-size: 14px;
        color: #C0C8D5;
        height: 24px!important;
        line-height: 24px!important;
        margin-left: 10px!important;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
      }
    }
    .color-black {
      color: #354052;
    }
    .icon-arrow {
      right: 20px;
      position: absolute;
    }
    &:hover,
    &.select {
      img.header-icon {
        content: url('//img1.jianyewy.com/daeff7042fe878d44d07459e21fb6bcb.png');
      }
      span { 
        color: #FFFFFF!important;
      }
    }
    &:hover {
      background: rgba(79,158,250,0.40)!important;
      img.arrow {
        content: url('//img1.jianyewy.com/407d14511a4334587dfcdf72b8e8a128.png');
      }
    }
    &.select {
      background: #4F9EFA!important;
      img.arrow {
        content: url('//img1.jianyewy.com/3db969696355818ad5a5ffd5258024d7.png');
      }
    }
  }
  .saas-content .saas-menu .grid-item1.user-header1{
    border-left: none!important;
  }
  .user-header1{
    width: 167px!important;
    // padding: 13px 20px!important;
    text-align: left!important;
    justify-content: inherit!important;
    a {
      padding: 13px 20px!important;
      display: inline-flex!important;
      text-align: left!important;
      justify-content: inherit!important;
      span {
        width: 70px;
        font-size: 14px;
        color: #C0C8D5;
        height: 24px!important;
        line-height: 24px!important;
        margin-left: 10px!important;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
      }
    }
    .color-black {
      color: #354052;
    }
    .icon-arrow {
      right: 20px;
      position: absolute;
    }
    &:hover,
    &.select {
      img.header-icon {
        content: url('//img1.jianyewy.com/daeff7042fe878d44d07459e21fb6bcb.png');
      }
    }
    &:hover {
      background: rgba(79,158,250,0.40)!important;
      img.arrow {
        content: url('//img1.jianyewy.com/407d14511a4334587dfcdf72b8e8a128.png');
      }
    }
    &.select {
      background: #4F9EFA!important;
      span { 
        color: #FFFFFF!important;
      }
      img.arrow {
        content: url('//img1.jianyewy.com/3db969696355818ad5a5ffd5258024d7.png');
      }
    }
  }
  .dropdown-header {
    z-index: 6000;
    background-clip: padding-box;
    background: #FFFFFF;
    box-shadow: 0 0 6px 0 rgba(111,126,149,0.50);
    border-radius: 4px;
    padding: 0;
    list-style: none;
    position: absolute;
    right: 0;
    left: auto;
    width: 167px;
    top: 60px;
    cursor: auto;
    ul {
      width: 100%;
      font-size: 14px;
      list-style: none;
      li {
        height: 40px;
        line-height: 20px;
        // border-bottom: 1px solid #EBF1F5;
        span {
          width: 100%;
          color: #354052;
          font-size: 13px;
          letter-spacing: 0;
          line-height: 14px;
          margin: 0 10px;
          height: 16px;
          line-height: 16px;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
        }
        a {
          width: 100%;
          display: inline-flex;
          padding: 12px 20px;
          text-align: left;
          cursor: pointer;
          // border-bottom: 1px solid #D8DFE5;
        }
        a:hover {
          background-color: #F1F6FA;
          position: absolute;
        }
        .bot-line {
          border-bottom: 1px solid #EBF1F5;
          margin: 0 10px;
        }
      }
      .footer span{
        color: #E95E90;
        text-align: center;
        width: 100%;
      }
    }
  }
  .noticeDlg {
    position: absolute;
    top: 50%;
    left: 50%;
    margin: 0 !important;
    transform: translate(-50%, -50%);
    .el-dialog__header {
      padding: 9px 20px;
      background: #6F7E95;
      .el-dialog__title {
        font-size: 14px;
        color: #FFFFFF;
        line-height: 14px;
      }
    }
    .el-dialog__body {
      padding: 0;
      border: 1px solid #D8DFE5;
      .el-form-item__content {
        width: 350px;
      }
      .el-container {
        .el-header{
          padding: 20px;
          .title {
            margin-bottom: 10px;
            font-size: 16px;
            color: #354052;
            line-height: 20px;
          }
          .des {
            font-size: 14px;
            color: #9BA3AF;
            line-height: 14px;
          }
        }
        .el-main {
          min-height: 250px;
          max-height: 454px;
          padding-top: 0;
          padding-bottom: 0;
          margin-bottom: 20px;
          .content {
            min-height: 179px;
            font-size: 14px;
            color: #6F7E95;
            letter-spacing: 0;
          }
          .line {
            border-top: 1px solid #EBF1F5;
            margin: 20px -20px;
          }
          .footer {
            text-align: center;
            .el-button {
              padding: 7px 21px;
            }
          }
        }
        .el-main::-webkit-scrollbar{
          width: 2px;
          height: 2px;
          background-color: #F5F5F5;
        }
        .el-main::-webkit-scrollbar-track
        {
          -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
          border-radius: 10px;
        }
        .el-main::-webkit-scrollbar-thumb
        {
          border-radius: 10px;
          -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
        }
      }
    }
    .el-dialog__footer {
      padding: 20px;
      text-align: center;
      .el-button {
        padding: 7px 21px;
      }
    }
  }
}
</style>
